import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@mui/material";
import * as datetime from "common/utils/datetime";
import Resource from "common/components/Resource";
import { get, find } from "lodash";
import { withStyles } from "@mui/styles";
import { withRouter } from "react-router";
import { compose } from "redux";
import { useTranslation } from "react-i18next";
import { withUrlResource, withUrlResourceTimezone } from "common/utils";

const offerTemplate = (id, templates) =>
  get(find(templates, { id }), "name", id);

const OfferList = ({ offers, classes, resource, urlResource, history }) => {
  const { t } = useTranslation();
  return (
    <Resource
      name="offer_templates"
      render={(offerTemplates) => (
        <Table classes={{ root: classes.root }}>
          <TableHead>
            <TableRow>
              <TableCell classes={{ root: classes.th }}>
                {t("offers_list.th_name")}
              </TableCell>
              <TableCell classes={{ root: classes.th }}>
                {t("offers_list.th_type")}
              </TableCell>
              <TableCell classes={{ root: classes.th }}>
                {t("offers_list.th_published_date")}
              </TableCell>
              <TableCell classes={{ root: classes.th }}>
                {t("offers_list.th_valid_start")}
              </TableCell>
              <TableCell classes={{ root: classes.th }}>
                {t("offers_list.th_valid_end")}
              </TableCell>
              {/* <TableCell classes={{ root: classes.th }}>{t("offers_list.th_status")}</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {offers.map((offer) => (
              <TableRow key={offer.id}>
                <TableCell
                  className={classes.clickable}
                  onClick={() => {
                    history.push(
                      `/${resource.singular}/${resource.id}/offers/review/${offer.id}`,
                    );
                  }}
                >
                  {offer.name}
                </TableCell>
                <TableCell className={classes.td}>
                  {offerTemplate(offer.offer_template, offerTemplates)}
                </TableCell>
                <TableCell className={classes.td}>
                  {offer.published_at
                    ? datetime.full(offer.published_at, urlResource.timezone)
                    : ""}
                </TableCell>
                <TableCell className={classes.td}>
                  {datetime.full(offer.start_at, urlResource.timezone)}
                </TableCell>
                <TableCell className={classes.td}>
                  {datetime.full(offer.end_at, urlResource.timezone)}
                </TableCell>
                {/* <TableCell className={classes.td}>
                <OfferStatus status={offer.status} />
              </TableCell> */}
              </TableRow>
            ))}

            {offers.length === 0 && (
              <TableRow>
                <TableCell colSpan={5}>{t("offers_list.no_records")}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    />
  );
};

OfferList.propTypes = {
  offers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      offer_template: PropTypes.string.isRequired,
      published_at: PropTypes.string.isRequired,
      start_at: PropTypes.string.isRequired,
      end_at: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }),
  ).isRequired,
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  root: {
    padding: 0,
  },
  th: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: "#7f7f7f",
    color: "#fff",
    fontWeight: "bold",
  },
  td: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  clickable: {
    cursor: "pointer",
    color: "#000",
    textDecoration: "underline",
    fontWeight: "bold",
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
});

const enhanced = compose(
  withRouter,
  withStyles(styles),
  withUrlResource,
  withUrlResourceTimezone,
);

export default enhanced(OfferList);
